export const bookingStyles = {
  left: {
    marginLeft: 0
  },
  required: {
    color: 'red'
  }
}
